import spartaStoreUtility from "global/sparta-store-utility";
import _ from "vendor/lodash";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaMediaQueryConstantsUtility from "global/sparta-mediaquery-constants-utility";




export const utilityNamespace = 'spartaMediaQueryUtility';





const breakpointEventName = 'BREAKPOINT_CHANGE';





const widgetResizeEventName = 'WIDGET_RESIZE';





const EVENTS = {
  [breakpointEventName]: `${breakpointEventName}.${utilityNamespace}`,
  [widgetResizeEventName]: `${widgetResizeEventName}.${utilityNamespace}`,
};

export default EVENTS;
